module.exports = __webpack_public_path__ + "static/media/danger.ea848713.svg";